import { DeleteOutline } from "@mui/icons-material";
import { GridColDef } from "@mui/x-data-grid-pro";
import { TablePage } from "components/alove/TablePage";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getAutocompleteAnswers, updateAutocompleteAnswers } from "utils/attributesUtil";
import { getProfileByAttribute } from "utils/enduserUtils";

export const AutocompleteAnswers = () => {
  const [refresh, setRefresh] = useState(false);


  const {id} = useParams<{id: string}>();
  const columns:GridColDef[] = [{
    headerName: 'Old Value',
    field: 'value',
    flex: 1,
  },{
    headerName: 'New Value',
    field: 'newValue',
    flex: 1,
    editable: true,
  },{
    headerName: 'Count',
    field: 'count',
    flex: 1,
  }];

  const loadAutocompleteAnswers = async () => {
    const autocompleteAnswers = await getAutocompleteAnswers(id);
    return autocompleteAnswers.sort((a, b) => a.value.trim().localeCompare(b.value.trim()));
  };

  const proccessRowUpdate = (newRow, oldRow) => {
    if (!newRow.newValue) {
      return oldRow;
    }
    updateAutocompleteAnswers({
      key: newRow.key,
      newValue: newRow.newValue,
      oldValue: oldRow.value
    }).then (() => {
      setRefresh(!refresh);
    });
    return newRow;
  }

  const onRowClick = ({row}) => {
    getProfileByAttribute(id!, row.value).then((res) => {
      res.slice(0, 3).forEach((profile) => {
        window.open(`#/endusers/${profile.profileId}`, "_blank");
      }
      );
    })
  }

  return (
    <DashboardLayout>
      <DashboardNavbar pageTitle="Autocomplete Answers" />
      <TablePage
        title="Autocomplete Answers"
        refresh={refresh}
        table={{
          columns,
          getRowId: (row) => row.key + row.value,
          loadNext: loadAutocompleteAnswers,
          processRowUpdate: proccessRowUpdate,
          
          lineDoubleClick: onRowClick,
          groupingColDef:{
            width: 400,
          }
        }}

      />
    </DashboardLayout>
  );
};
